export default __webpack_public_path__ + "static/media/56.21c6dee4.jpg";